import { render } from "./BaseSlider.vue?vue&type=template&id=31fb92e2&scoped=true&ts=true"
import script from "./BaseSlider.vue?vue&type=script&lang=ts"
export * from "./BaseSlider.vue?vue&type=script&lang=ts"

import "./BaseSlider.vue?vue&type=style&index=0&id=31fb92e2&scoped=true&lang=scss"
import "./BaseSlider.vue?vue&type=style&index=1&id=31fb92e2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fb92e2"]])

export default __exports__